module.exports = __webpack_public_path__ + "img/datetime.81740a5a.svg";